'use client';

import { Badge } from '@/components/ui/badge';
import { BRIEFING_TYPES, type BriefingType } from '@/types/briefing-type';
import { cn } from '@/lib/utils';

interface BriefingTypeBadgeProps {
  type: BriefingType;
  className?: string;
}

/**
 * Shared badge component for displaying briefing type.
 * Used in: briefing view header, history cards, admin table, PDF header.
 *
 * - standard: subtle gray (low-contrast, not prominent)
 * - benefits: blue
 * - ma: amber
 */
export function BriefingTypeBadge({ type, className }: BriefingTypeBadgeProps) {
  const info = BRIEFING_TYPES[type] ?? BRIEFING_TYPES.standard;

  return (
    <Badge
      variant="outline"
      className={cn('text-[11px] font-medium', info.badgeClass, className)}
    >
      {info.label}
    </Badge>
  );
}
